// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2JVhf","label":"Completed_label__193iQ"};